import { render, staticRenderFns } from "./Manage-Motor-Settings.vue?vue&type=template&id=5ce81456"
import script from "./Manage-Motor-Settings.vue?vue&type=script&lang=js"
export * from "./Manage-Motor-Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports